import { render } from "./InstagramGallery.vue?vue&type=template&id=8ab4766c&bindings={\"igKey\":\"props\",\"pageId\":\"props\",\"prev\":\"options\",\"hasMedia\":\"options\",\"hasDetail\":\"options\",\"getMedias\":\"options\"}"
import script from "./InstagramGallery.vue?vue&type=script&lang=js"
export * from "./InstagramGallery.vue?vue&type=script&lang=js"

import "./InstagramGallery.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script